/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import {
  ApiComponent,
  ApiComponentFromJSON,
  ApiComponentFromJSONTyped,
  ApiComponentToJSON,
} from './ApiComponent';
import {
  ApiConstraint,
  ApiConstraintFromJSON,
  ApiConstraintFromJSONTyped,
  ApiConstraintToJSON,
} from './ApiConstraint';
import { ApiCopy, ApiCopyFromJSON, ApiCopyFromJSONTyped, ApiCopyToJSON } from './ApiCopy';
import { ApiHeader, ApiHeaderFromJSON, ApiHeaderFromJSONTyped, ApiHeaderToJSON } from './ApiHeader';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';
import { ApiLink, ApiLinkFromJSON, ApiLinkFromJSONTyped, ApiLinkToJSON } from './ApiLink';
import {
  ApiStandardNonSkuAllOf,
  ApiStandardNonSkuAllOfFromJSON,
  ApiStandardNonSkuAllOfFromJSONTyped,
  ApiStandardNonSkuAllOfToJSON,
} from './ApiStandardNonSkuAllOf';
import {
  ApiStandardNonSkuItem,
  ApiStandardNonSkuItemFromJSON,
  ApiStandardNonSkuItemFromJSONTyped,
  ApiStandardNonSkuItemToJSON,
} from './ApiStandardNonSkuItem';

/**
 *
 * @export
 * @interface ApiStandardNonSku
 */
export interface ApiStandardNonSku extends ApiComponent {
  /**
   *
   * @type {Array<ApiStandardNonSkuItem>}
   * @memberof ApiStandardNonSku
   */
  items?: Array<ApiStandardNonSkuItem>;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  backgroundColor?: string;
  /**
   *
   * @type {ApiHeader}
   * @memberof ApiStandardNonSku
   */
  header?: ApiHeader;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  imageCrop?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardNonSku
   */
  imageVeil?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  layoutType?: string;
  /**
   *
   * @type {ApiLink}
   * @memberof ApiStandardNonSku
   */
  link?: ApiLink;
  /**
   *
   * @type {number}
   * @memberof ApiStandardNonSku
   */
  maxItems?: number;
  /**
   *
   * @type {number}
   * @memberof ApiStandardNonSku
   */
  minItems?: number;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  orientationMobile?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  recipeType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  shapeDescription?: string;
  /**
   *
   * @type {ApiCopy}
   * @memberof ApiStandardNonSku
   */
  subText?: ApiCopy;
  /**
   *
   * @type {ApiLink}
   * @memberof ApiStandardNonSku
   */
  subTitleLink?: ApiLink;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  subTitleOptions?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardNonSku
   */
  tileTitleTextSize?: string;
  /**
   *
   * @type {Array<ApiConstraint>}
   * @memberof ApiStandardNonSku
   */
  constraints: Array<ApiConstraint>;
}

export function ApiStandardNonSkuFromJSON(json: any): ApiStandardNonSku {
  return ApiStandardNonSkuFromJSONTyped(json, false);
}

export function ApiStandardNonSkuFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiStandardNonSku {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    ...ApiComponentFromJSONTyped(json, ignoreDiscriminator),
    items: !exists(json, 'items')
      ? undefined
      : (json['items'] as Array<any>).map(ApiStandardNonSkuItemFromJSON),
    backgroundColor: !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
    header: !exists(json, 'header') ? undefined : ApiHeaderFromJSON(json['header']),
    imageCrop: !exists(json, 'imageCrop') ? undefined : json['imageCrop'],
    imageVeil: !exists(json, 'imageVeil') ? undefined : json['imageVeil'],
    layoutType: !exists(json, 'layoutType') ? undefined : json['layoutType'],
    link: !exists(json, 'link') ? undefined : ApiLinkFromJSON(json['link']),
    maxItems: !exists(json, 'maxItems') ? undefined : json['maxItems'],
    minItems: !exists(json, 'minItems') ? undefined : json['minItems'],
    orientationMobile: !exists(json, 'orientationMobile') ? undefined : json['orientationMobile'],
    recipeType: !exists(json, 'recipeType') ? undefined : json['recipeType'],
    shapeDescription: !exists(json, 'shapeDescription') ? undefined : json['shapeDescription'],
    subText: !exists(json, 'subText') ? undefined : ApiCopyFromJSON(json['subText']),
    subTitleLink: !exists(json, 'subTitleLink') ? undefined : ApiLinkFromJSON(json['subTitleLink']),
    subTitleOptions: !exists(json, 'subTitleOptions') ? undefined : json['subTitleOptions'],
    tileTitleTextSize: !exists(json, 'tileTitleTextSize') ? undefined : json['tileTitleTextSize'],
    constraints: !exists(json, 'constraints')
      ? []
      : (json['constraints'] as Array<any>).map(ApiConstraintFromJSON),
  };
}

export function ApiStandardNonSkuToJSON(value?: ApiStandardNonSku | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    ...ApiComponentToJSON(value),
    items:
      value.items === undefined
        ? undefined
        : (value.items as Array<any>).map(ApiStandardNonSkuItemToJSON),
    backgroundColor: value.backgroundColor,
    header: ApiHeaderToJSON(value.header),
    imageCrop: value.imageCrop,
    imageVeil: value.imageVeil,
    layoutType: value.layoutType,
    link: ApiLinkToJSON(value.link),
    maxItems: value.maxItems,
    minItems: value.minItems,
    orientationMobile: value.orientationMobile,
    recipeType: value.recipeType,
    shapeDescription: value.shapeDescription,
    subText: ApiCopyToJSON(value.subText),
    subTitleLink: ApiLinkToJSON(value.subTitleLink),
    subTitleOptions: value.subTitleOptions,
    tileTitleTextSize: value.tileTitleTextSize,
    constraints: (value.constraints as Array<any>).map(ApiConstraintToJSON),
  };
}
